<!-- =========================================================================================
    File Name: DeviceAddPopup.vue
    Description: Dashcam add popup 
========================================================================================== -->

<template>
  <div>
    <vs-popup :title="$t('ADD_DEVICE')" :active.sync="isPopupActiveLocal">
      
      <div class="tab-text">
        <div class="m-5">
          <vs-input :label="$t('DEVICE_UUID')" class="mt-5 w-full" name="deviceUUID" v-model="deviceUUID" v-validate="{ required: true, regex:/^[A-Z]{6}[A-Z]{1}[0-9]{2}([0-9]|[A-Z]){1}[A-Z]{1}([1-9]|[A-C]){1}([0-9]|[A-Z]){4}$/}" icon-pack="feather" icon="icon-video" icon-no-border />
          <span class="text-danger text-sm" v-show="errors.has('deviceUUID')">{{ errors.first('deviceUUID') }}</span>
        </div> 

        <div class="m-5">
          <vs-input :label="$t('DEVICE_SECURITY_KEY')" class="mt-5 w-full" name="deviceSecurityKey" v-model="deviceSecurityKey" v-validate="{ required: true,  min:8, max:8 }" v-mask="'NNNNNNNN'" icon-pack="feather" icon="icon-lock" icon-no-border />
          <span class="text-danger text-sm" v-show="errors.has('deviceSecurityKey')">{{ errors.first('deviceSecurityKey') }}</span>
        </div> 

        <vs-divider />

        <div class="float-right">
          <vs-button class="mr-5" @click="checkAdd" :disabled="!isFormValid">{{$t('SUBMIT')}}</vs-button>
          <vs-button type="border" color="danger" @click.stop="isPopupActiveLocal = false">{{$t('CLOSE')}}</vs-button>
        </div>
      </div>

      <vs-popup class="sidebar-popup" :title="this.$t('CONFIRM')" :active.sync="confirmPopup">
        <p>{{this.$t('SUBMIT_CONFIRM_MESSAGE')}}</p>
        <div class="float-right mt-5">
          <vs-button @click="acceptAdd" color="danger" type="filled">{{this.$t('CONFIRM')}}</vs-button>
          <vs-button @click="confirmPopup = false" color="dark" type="flat">{{this.$t('CANCEL')}}</vs-button>
        </div>
      </vs-popup>

    </vs-popup>
  </div>
</template>

<script>
import ImportExcel from "@/components/excel/ImportExcel.vue"

export default {
  components: {
    ImportExcel
  },
  props: {
    isPopupActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  computed: {
    isPopupActiveLocal: {
      get() {
        return this.isPopupActive
      },
      set(val) {
        if(!val) {
          this.$emit('close')
          this.initValues()
        }
      }
    },
    isFormValid() {
        return !this.errors.any() && this.deviceUUID != '' && this.deviceSecuritykey != ''
    },
  },
  data() {
    return {
      deviceUUID: "",
      deviceSecurityKey: "",
      confirmPopup: false
    }
  },
  methods: {
    initValues(){
      this.deviceUUID = ""
      this.deviceSecurityKey = ""
    },
    checkAdd(){
        this.$validator.validateAll().then(result => {
        if(result){
          this.confirmPopup = true
        }
      })
      .catch((error)=>{
          this.errorAlert(this.$t("ERROR"), error.message)
      })
    },
    popupClose(){
      this.confirmPopup = false
      this.initValues()
      this.$vs.loading.close()
    },
    acceptAdd(){
      this.$vs.loading()
      const deviceInfo = {
          deviceUUID: this.deviceUUID,
          deviceSecurityKey: this.deviceSecurityKey
      }

      this.$store.dispatch("dataDevice/updateDeviceUUID", deviceInfo)
      .then(() => {
        this.$parent.$refs.deviceTable.getData()
        this.popupClose()
        this.$emit('close')
        this.successAlert(this.$t("SUCCESS"),this.$t("ADD_DEVICE_SUCCESS"))
      })
      .catch(error => { 
        this.popupClose()
        if(error === "DUPLICATE_DEVICE_UUID_MESSAGE"){
          this.errorAlert(this.$t("ERROR"), this.$t(error))
        }else{
          console.log(error.code)
          this.errorAlert(this.$t("ERROR"), error.message)
        }
      })
    }
  }
}
</script>
